import { FormDescription } from "../FormDescription";
import { WelcomeSection } from "../WelcomeSection";
import { FormStepLayout } from "./FormStepLayout";

interface CompleteFormCoverProps {
    handleNextStep: () => void,
    handlePreviousStep: () => void,
    activeStep: number,
    title?: string,
    subtitle?: string,
    description?: string,
    descriptionTitle?: string,
    descriptionText?: string,
    totalSteps?: number
}

export default function CompleteFormCover({ 
    handleNextStep, 
    handlePreviousStep, 
    activeStep, 
    title, 
    subtitle, 
    description,
    descriptionTitle,
    descriptionText,
    totalSteps = 25
}: CompleteFormCoverProps) {
    return (
        <FormStepLayout
            activeStep={activeStep}
            totalSteps={totalSteps}
            onNext={handleNextStep}
            onPrevious={handlePreviousStep}
            onSubmit={handleNextStep}
            isValid={true}
            isFormComplete={false}
            isCoverPage={true}
        >
            <WelcomeSection 
                title={title}
                subtitle={""}
                description={description}
            />
            <div className="h-6 sm:h-10"></div>
            <FormDescription 
                title={descriptionTitle}
                text={descriptionText}
            />
        </FormStepLayout>
    )
}